document.addEventListener("DOMContentLoaded", function () {
  /*
  const checkCartItems = () => {
    if (wof$("#lbl_cart_total").text() > 0) {
      wof$("#lbl_cart_total").addClass("hasItems");
    } else {
      wof$("#lbl_cart_total").removeClass("hasItems");
    }
  };

  wof$("#lbl_cart_total").on("change", function () {
    checkCartItems();
  });

  checkCartItems();
  */
  const inputWrapper = document.createElement("div");
  inputWrapper.id = "filterWrapper";

  const filterInput = document.createElement("input");
  filterInput.type = "text";
  filterInput.id = "filterInput";
  filterInput.placeholder = "Filter collections...";

  inputWrapper.appendChild(filterInput);
  document
    .getElementById("lbl_filter_collection_header")
    .insertBefore(
      inputWrapper,
      document.getElementById("lbl_filter_collection_header")[0]
    );

  // Filter logic
  const collectionItems = document.querySelectorAll(
    "#collections_wrapper .collection-filter"
  );

  filterInput.addEventListener("input", function () {
    const filterText = filterInput.value.toLowerCase();
    collectionItems.forEach((item) => {
      const text = item.textContent.toLowerCase();
      if (text.includes(filterText)) {
        item.classList.remove("hidden");
      } else {
        item.classList.add("hidden");
      }
    });
  });
});

const filterSearchVariants = (data) => {
  const searchText = wof$("#wof_txt_search").val().trim().toLowerCase();

  if (
    searchText == "" ||
    isNaN(searchText.charAt(0)) ||
    searchText.length > 10
  ) {
    return data;
  }

  for (var key in data.productItems) {
    const product = data.productItems[key];
    for (var vkey in product.productVariants) {
      if (
        !product.productVariants[vkey].variantSku
          .toLowerCase()
          .startsWith(searchText)
      ) {
        delete data.productItems[key].productVariants[vkey];
      }
    }
    if (product.productVariants != undefined) {
      data.productItems[key].productVariants = data.productItems[
        key
      ].productVariants.filter((_) => true);
      if (product.productVariants.length < 1) {
        delete data.productItems[key];
      }
    }
  }
  if (data.productItems != undefined) {
    data.productItems = data.productItems.filter((_) => true);
  }
  return data;
};

class wofAjax {
  ajaxRequest(
    url,
    method,
    callbackFunction,
    _this = null,
    parameters = null,
    async = true,
    dataType = null
  ) {
    wof$.ajax({
      url: url,
      dataType: dataType,
      data: parameters,
      success: function (json) {
        if (url.includes("/search?")) {
          const responseData = filterSearchVariants(stringToJson(json));
          callbackFunction(JSON.stringify(responseData));
        } else {
          callbackFunction(json);
        }
      },
      async: async,
      type: method,
      error: function (XMLHttpRequest) {
        var response = eval("(" + XMLHttpRequest.responseText + ")");
        if (XMLHttpRequest.status == 0) {
          response = {
            status: 0,
            description:
              wofConfig.settings.translate.messages
                .internet_connectivity_error,
          };
        }

        callbackFunction(response);
      },
    });
  }
}


document.addEventListener("DOMContentLoaded", function () {
  var cartItemCount = window.cartItemCount;
  var newCartHTML = `
    <a href="/cart" class="header__icon header__icon--cart link focus-inset" id="cart-icon-bubble">
      <svg class="icon icon-cart" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 35" fill="none">
        <path fill="currentColor" fill-rule="evenodd" d="M20.5 6.5a4.75 4.75 0 00-4.75 4.75v.56h-3.16l-.77 11.6a5 5 0 004.99 5.34h7.38a5 5 0 004.99-5.33l-.77-11.6h-3.16v-.57A4.75 4.75 0 0020.5 6.5zm3.75 5.31v-.56a3.75 3.75 0 10-7.5 0v.56h7.5zm-7.5 1h7.5v.56a3.75 3.75 0 11-7.5 0v-.56zm-1 0v.56a4.75 4.75 0 109.5 0v-.56h2.22l.71 10.67a4 4 0 01-3.99 4.27h-7.38a4 4 0 01-4-4.27l.72-10.67h2.22z"></path>
      </svg>
      <span class="visually-hidden">Cart</span>
      <div class="cart-count-bubble">
        ${cartItemCount < 100 ? `<span aria-hidden="true">${cartItemCount}</span>` : ''}
        <span class="visually-hidden">${cartItemCount} items</span>
      </div>
    </a>
  `;

  var oldCartElement = document.getElementById("wof_cart_widget_wrapper");
  oldCartElement.innerHTML = newCartHTML;
});



document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('.wof-add-to-cart-button').forEach(function (button) {
        button.addEventListener('click', function (event) {
            event.preventDefault();
            var variantId = this.getAttribute('data-variant-id');

            addToCart(variantId, 1);
        });
    });

    function addToCart(variantId, quantity) {
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                id: variantId,
                quantity: quantity
            })
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
        })
        .then(data => {
            console.log('Product added to cart:', data);
            updateCartCount();
        })
        .catch(error => {
            console.error('Error adding product to cart:', error);
        });
    }

    function updateCartCount() {
        fetch('/cart.js', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
        })
        .then(data => {
            console.log('Cart data:', data);
            var cartCount = data.item_count;

            var cartCountElements = document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]');
            cartCountElements.forEach(function (element) {
                element.textContent = cartCount;
            });

            var cartCountBubble = document.querySelector('.cart-count-bubble');
            if (cartCountBubble) {
                if (cartCount === 0) {
                    cartCountBubble.style.display = 'none';
                } else {
                    cartCountBubble.style.display = 'block';
                }
            }
        })
        .catch(error => {
            console.error('Error fetching cart data:', error);
        });
    }

    setInterval(updateCartCount, 3000);

    updateCartCount();
});

